function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 60,
    "aria-label": "Next.js logotype",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "var(--geist-foreground)",
    d: "M79.606 20.12h19.16v3.537h-7.6v18.605h-3.801V23.657h-7.76zm-31.512 0v3.537H32.736v5.69h12.351v3.536h-12.35v5.843h15.357v3.537H28.936V23.657h-.002v-3.536zm9.568.01h-4.974l17.814 22.142h4.988l-8.908-11.064 8.894-11.061-4.974.008-6.41 7.961zm5.103 15.816-2.49-3.097-7.601 9.44h4.988z",
    style: {
      strokeWidth: 0.279193
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--geist-foreground)",
    fillRule: "evenodd",
    d: "m29.069 42.262-17.838-22.15H6.48v22.141h3.8V24.845l14.014 17.417z",
    clipRule: "evenodd",
    style: {
      strokeWidth: 0.279193
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--geist-foreground)",
    d: "M99.62 42.127a.99.99 0 0 1-.713-.289.93.93 0 0 1-.293-.703q-.004-.403.293-.693a.99.99 0 0 1 .714-.289q.402 0 .7.29a.94.94 0 0 1 .304.692.96.96 0 0 1-.142.5 1.03 1.03 0 0 1-.368.358.95.95 0 0 1-.494.134m6.486-9.327h1.684v6.488q-.004.893-.384 1.535a2.55 2.55 0 0 1-1.06.987q-.678.344-1.579.345-.822-.001-1.478-.292a2.38 2.38 0 0 1-1.04-.862q-.385-.571-.384-1.424h1.687q.004.374.167.645a1.1 1.1 0 0 0 .448.413q.29.145.664.145c.27 0 .503-.056.69-.17q.282-.168.433-.503.148-.33.152-.819zm8.613 2.537a1.22 1.22 0 0 0-.535-.918q-.475-.331-1.229-.33a2.4 2.4 0 0 0-.908.157 1.37 1.37 0 0 0-.582.429q-.2.27-.206.616 0 .29.136.5.134.214.368.358a2.5 2.5 0 0 0 .515.246q.286.1.572.168l.878.215a6 6 0 0 1 1.022.33 3.6 3.6 0 0 1 .883.523 2.35 2.35 0 0 1 .619.761q.228.445.229 1.046 0 .809-.42 1.426-.42.612-1.215.959-.791.344-1.919.345c-.726 0-1.36-.112-1.892-.335q-.803-.331-1.255-.972-.45-.64-.486-1.558h1.669a1.4 1.4 0 0 0 .3.802q.268.318.693.477.429.157.958.157.553 0 .974-.165.418-.163.654-.46.24-.292.242-.69a.9.9 0 0 0-.214-.598q-.212-.236-.587-.396a6 6 0 0 0-.88-.286l-1.067-.27q-1.156-.293-1.826-.89t-.67-1.589q0-.815.452-1.428.448-.613 1.225-.952.78-.341 1.762-.34.995-.001 1.748.34.753.339 1.182.942.43.6.443 1.38z",
    style: {
      strokeWidth: 0.279193
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjs);
export default __webpack_public_path__ + "static/media/nextjs.066e484ace046643edaa54a798635c90.svg";
export { ForwardRef as ReactComponent };